// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* A provenance history, listed as Curio's Nest lists work: rows hanging from
   rails, each branch folded under the item it left from. */

.cRIe_2DNakLMYv33ZMyp {
    font-family: var(--curio-font-family);
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-primary);
}

/* ── An item: one row ──────────────────────────────────────────────────── */

.wGfuHUXcwHJKOq6oCjfI {
    position: relative;
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-md);
}

.oy7IxWAyoGQOg13i7qyl {
    display: grid;
    grid-template-columns: 10px auto minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
    width: 100%;
    min-height: 34px;
    padding: 6px 10px;
    border: 0;
    border-radius: inherit;
    background: none;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
}

.oy7IxWAyoGQOg13i7qyl:hover {
    background: var(--curio-surface-muted);
}

.oy7IxWAyoGQOg13i7qyl:focus-visible {
    outline: 2px solid var(--curio-accent-sky-fg);
    outline-offset: -2px;
}

/* Hollow for every item, filled for the one in use: the version on the canvas,
   or the run the node's next run branches from. */
.Vds1jmvw_gN6IJn7JXCg {
    width: 10px;
    height: 10px;
    box-sizing: border-box;
    border: 1.6px solid #9aa0aa;
    border-radius: 50%;
    background: var(--curio-card-bg);
}

.X2YjaUbBR6YxobBAzvaa .Vds1jmvw_gN6IJn7JXCg {
    border-color: var(--curio-text-primary);
    background: var(--curio-text-primary);
}

/* The item's number, as the Nest tags a step. */
.eBCXq4OObgPYszWa64an {
    min-width: 22px;
    padding: 0 4px;
    border-radius: var(--curio-radius-sm);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: 600 10.5px/17px var(--curio-font-mono);
    text-align: center;
}

._pvNVbgs3UVqG5a3LECO {
    min-width: 0;
    overflow: hidden;
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.AJAggCQTbALAcYdTMfAf {
    color: var(--curio-text-meta);
    font-size: var(--curio-font-size-sm);
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

/* What an opened item shows, under a blue edge as the Nest opens a step. */
.JjQSTk97qA8OZwiNy6Qw {
    display: grid;
    gap: 8px;
    margin: 0 10px 10px 28px;
    padding: 2px 0 2px 12px;
    border-left: 3px solid var(--curio-accent-sky-fg);
    color: var(--curio-text-secondary);
    font-size: var(--curio-font-size-sm);
}

/* ── List ──────────────────────────────────────────────────────────────── */

/* Each line hangs from a rail on its left, with an elbow into every row: grey
   for the main line, blue for a branch, green one level further down. */
.bDUmPRlrtYXdFv_h4mXP {
    --tree: #9aa0aa;
    position: relative;
    display: grid;
    gap: 8px;
    margin: 12px 0 0;
    padding: 0 0 0 22px;
    list-style: none;
}

.bDUmPRlrtYXdFv_h4mXP.iRWWfNE5NQfUnRrxa0Ei {
    --tree: var(--curio-accent-sky-fg);
}

.bDUmPRlrtYXdFv_h4mXP.MX8Px_0xjqhqvIdClZN6 {
    --tree: var(--curio-accent-mint-fg);
}

.bDUmPRlrtYXdFv_h4mXP::before {
    content: "";
    position: absolute;
    left: 4px;
    top: -11px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--tree);
}

.RQzdBdO0BUB1LfBXcBa3 {
    position: relative;
}

.RQzdBdO0BUB1LfBXcBa3::before {
    content: "";
    position: absolute;
    left: -16px;
    top: -9px;
    bottom: -1px;
    border-left: 2px solid var(--tree);
}

.RQzdBdO0BUB1LfBXcBa3:last-child::before {
    bottom: auto;
    height: 27px;
}

.RQzdBdO0BUB1LfBXcBa3::after {
    content: "";
    position: absolute;
    left: -16px;
    top: 16px;
    width: 15px;
    border-top: 2px solid var(--tree);
}

.NVsnwzFr12M19WRAvf9K {
    display: grid;
    margin: 6px 0 0 14px;
}

/* One control for a branch folded under its item, as the Nest's fold. */
.JpzWoqcAzJYrTM9uAbIL {
    display: inline-flex;
    align-items: center;
    justify-self: start;
    gap: 4px;
    padding: 0;
    border: 0;
    background: none;
    color: var(--curio-accent-sky-fg);
    font: 500 11.5px/18px var(--curio-font-family);
    white-space: nowrap;
    cursor: pointer;
}

.JpzWoqcAzJYrTM9uAbIL svg {
    width: 10px;
    height: 10px;
    transition: transform 0.15s;
}

.JpzWoqcAzJYrTM9uAbIL[aria-expanded="true"] svg {
    transform: rotate(90deg);
}

.JpzWoqcAzJYrTM9uAbIL:hover span {
    text-decoration: underline;
}

/* ── Details parts ─────────────────────────────────────────────────────── */

.lzzE994WS78BwPZhQM5d {
    margin: 0;
    line-height: 1.4;
    overflow-wrap: anywhere;
}

.cuOlMKe8Jirod7bJH9YY {
    margin: 0;
    color: var(--curio-text-primary);
    font-weight: 500;
}

/* The one action an item has: put it back. */
.hVS2YPLjzhiOMGWbwvL4 {
    justify-self: start;
    min-height: 28px;
    padding: 5px 10px;
    border: 1px solid var(--curio-top-bar-bg);
    border-radius: var(--curio-radius-md);
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    font: 500 12px/1.3 var(--curio-font-family);
    text-align: left;
    cursor: pointer;
}

.hVS2YPLjzhiOMGWbwvL4:hover {
    background: var(--curio-top-bar-bg-hover);
}

/* The owner's: the history before the version goes. */
.I6qTek56fnMs3Md_OBA6 {
    justify-self: start;
    min-height: 28px;
    padding: 5px 10px;
    border: 1px solid var(--curio-danger-border);
    border-radius: var(--curio-radius-md);
    background: transparent;
    color: var(--curio-danger-text);
    font: 500 12px/1.3 var(--curio-font-family);
    text-align: left;
    cursor: pointer;
}

.I6qTek56fnMs3Md_OBA6:hover {
    background: var(--curio-danger-bg);
}

.wOqAbizyJjJ3XA5s0jC4 {
    width: 100%;
    max-width: 260px;
    aspect-ratio: 260 / 160;
    overflow: hidden;
    border: 1px solid var(--curio-border);
    border-radius: var(--curio-radius-sm);
}

/* A run's code, as it ran: lines scroll sideways, never wrap. */
.qNkOSWB8ok1aWZsPtf5T {
    max-height: 220px;
    margin: 0;
    padding: 8px 10px;
    overflow: auto;
    border-radius: var(--curio-radius-sm);
    background: var(--curio-surface-muted);
    color: var(--curio-text-primary);
    font: 11.5px/1.45 var(--curio-font-mono);
    white-space: pre;
}
`, "",{"version":3,"sources":["webpack://./src/components/provenance/ProvenanceHistory.module.css"],"names":[],"mappings":"AAAA;2DAC2D;;AAE3D;IACI,qCAAqC;IACrC,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA,6EAA6E;;AAE7E;IACI,kBAAkB;IAClB,gCAAgC;IAChC,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,oDAAoD;IACpD,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6CAA6C;IAC7C,oBAAoB;AACxB;;AAEA;kDACkD;AAClD;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;IACvC,qCAAqC;AACzC;;AAEA,gDAAgD;AAChD;IACI,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,4CAA4C;IAC5C,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA,2EAA2E;AAC3E;IACI,aAAa;IACb,QAAQ;IACR,wBAAwB;IACxB,uBAAuB;IACvB,iDAAiD;IACjD,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA,6EAA6E;;AAE7E;wEACwE;AACxE;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA,wEAAwE;AACxE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,iCAAiC;IACjC,8CAA8C;IAC9C,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,6EAA6E;;AAE7E;IACI,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA,6CAA6C;AAC7C;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yCAAyC;IACzC,qCAAqC;IACrC,mCAAmC;IACnC,gCAAgC;IAChC,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,sDAAsD;AACtD;IACI,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,4CAA4C;IAC5C,qCAAqC;IACrC,uBAAuB;IACvB,+BAA+B;IAC/B,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,qCAAqC;IACrC,qCAAqC;AACzC;;AAEA,gEAAgE;AAChE;IAEI,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;IAChC,wCAAwC;IACxC,gBAAgB;AACpB","sourcesContent":["/* A provenance history, listed as Curio's Nest lists work: rows hanging from\n   rails, each branch folded under the item it left from. */\n\n.history {\n    font-family: var(--curio-font-family);\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-primary);\n}\n\n/* ── An item: one row ──────────────────────────────────────────────────── */\n\n.item {\n    position: relative;\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-md);\n}\n\n.head {\n    display: grid;\n    grid-template-columns: 10px auto minmax(0, 1fr) auto;\n    align-items: center;\n    column-gap: 8px;\n    width: 100%;\n    min-height: 34px;\n    padding: 6px 10px;\n    border: 0;\n    border-radius: inherit;\n    background: none;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n}\n\n.head:hover {\n    background: var(--curio-surface-muted);\n}\n\n.head:focus-visible {\n    outline: 2px solid var(--curio-accent-sky-fg);\n    outline-offset: -2px;\n}\n\n/* Hollow for every item, filled for the one in use: the version on the canvas,\n   or the run the node's next run branches from. */\n.dot {\n    width: 10px;\n    height: 10px;\n    box-sizing: border-box;\n    border: 1.6px solid #9aa0aa;\n    border-radius: 50%;\n    background: var(--curio-card-bg);\n}\n\n.current .dot {\n    border-color: var(--curio-text-primary);\n    background: var(--curio-text-primary);\n}\n\n/* The item's number, as the Nest tags a step. */\n.tag {\n    min-width: 22px;\n    padding: 0 4px;\n    border-radius: var(--curio-radius-sm);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: 600 10.5px/17px var(--curio-font-mono);\n    text-align: center;\n}\n\n.title {\n    min-width: 0;\n    overflow: hidden;\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.when {\n    color: var(--curio-text-meta);\n    font-size: var(--curio-font-size-sm);\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n}\n\n/* What an opened item shows, under a blue edge as the Nest opens a step. */\n.details {\n    display: grid;\n    gap: 8px;\n    margin: 0 10px 10px 28px;\n    padding: 2px 0 2px 12px;\n    border-left: 3px solid var(--curio-accent-sky-fg);\n    color: var(--curio-text-secondary);\n    font-size: var(--curio-font-size-sm);\n}\n\n/* ── List ──────────────────────────────────────────────────────────────── */\n\n/* Each line hangs from a rail on its left, with an elbow into every row: grey\n   for the main line, blue for a branch, green one level further down. */\n.line {\n    --tree: #9aa0aa;\n    position: relative;\n    display: grid;\n    gap: 8px;\n    margin: 12px 0 0;\n    padding: 0 0 0 22px;\n    list-style: none;\n}\n\n.line.depth1 {\n    --tree: var(--curio-accent-sky-fg);\n}\n\n.line.depth2 {\n    --tree: var(--curio-accent-mint-fg);\n}\n\n.line::before {\n    content: \"\";\n    position: absolute;\n    left: 4px;\n    top: -11px;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--tree);\n}\n\n.entry {\n    position: relative;\n}\n\n.entry::before {\n    content: \"\";\n    position: absolute;\n    left: -16px;\n    top: -9px;\n    bottom: -1px;\n    border-left: 2px solid var(--tree);\n}\n\n.entry:last-child::before {\n    bottom: auto;\n    height: 27px;\n}\n\n.entry::after {\n    content: \"\";\n    position: absolute;\n    left: -16px;\n    top: 16px;\n    width: 15px;\n    border-top: 2px solid var(--tree);\n}\n\n.branch {\n    display: grid;\n    margin: 6px 0 0 14px;\n}\n\n/* One control for a branch folded under its item, as the Nest's fold. */\n.fold {\n    display: inline-flex;\n    align-items: center;\n    justify-self: start;\n    gap: 4px;\n    padding: 0;\n    border: 0;\n    background: none;\n    color: var(--curio-accent-sky-fg);\n    font: 500 11.5px/18px var(--curio-font-family);\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.fold svg {\n    width: 10px;\n    height: 10px;\n    transition: transform 0.15s;\n}\n\n.fold[aria-expanded=\"true\"] svg {\n    transform: rotate(90deg);\n}\n\n.fold:hover span {\n    text-decoration: underline;\n}\n\n/* ── Details parts ─────────────────────────────────────────────────────── */\n\n.detailLine {\n    margin: 0;\n    line-height: 1.4;\n    overflow-wrap: anywhere;\n}\n\n.inUse {\n    margin: 0;\n    color: var(--curio-text-primary);\n    font-weight: 500;\n}\n\n/* The one action an item has: put it back. */\n.restore {\n    justify-self: start;\n    min-height: 28px;\n    padding: 5px 10px;\n    border: 1px solid var(--curio-top-bar-bg);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    font: 500 12px/1.3 var(--curio-font-family);\n    text-align: left;\n    cursor: pointer;\n}\n\n.restore:hover {\n    background: var(--curio-top-bar-bg-hover);\n}\n\n/* The owner's: the history before the version goes. */\n.clear {\n    justify-self: start;\n    min-height: 28px;\n    padding: 5px 10px;\n    border: 1px solid var(--curio-danger-border);\n    border-radius: var(--curio-radius-md);\n    background: transparent;\n    color: var(--curio-danger-text);\n    font: 500 12px/1.3 var(--curio-font-family);\n    text-align: left;\n    cursor: pointer;\n}\n\n.clear:hover {\n    background: var(--curio-danger-bg);\n}\n\n.thumbnail {\n    width: 100%;\n    max-width: 260px;\n    aspect-ratio: 260 / 160;\n    overflow: hidden;\n    border: 1px solid var(--curio-border);\n    border-radius: var(--curio-radius-sm);\n}\n\n/* A run's code, as it ran: lines scroll sideways, never wrap. */\n.code {\n    composes: thinScrollbar from \"../../styles/scrollbars.module.css\";\n    max-height: 220px;\n    margin: 0;\n    padding: 8px 10px;\n    overflow: auto;\n    border-radius: var(--curio-radius-sm);\n    background: var(--curio-surface-muted);\n    color: var(--curio-text-primary);\n    font: 11.5px/1.45 var(--curio-font-mono);\n    white-space: pre;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"history": `cRIe_2DNakLMYv33ZMyp`,
	"item": `wGfuHUXcwHJKOq6oCjfI`,
	"head": `oy7IxWAyoGQOg13i7qyl`,
	"dot": `Vds1jmvw_gN6IJn7JXCg`,
	"current": `X2YjaUbBR6YxobBAzvaa`,
	"tag": `eBCXq4OObgPYszWa64an`,
	"title": `_pvNVbgs3UVqG5a3LECO`,
	"when": `AJAggCQTbALAcYdTMfAf`,
	"details": `JjQSTk97qA8OZwiNy6Qw`,
	"line": `bDUmPRlrtYXdFv_h4mXP`,
	"depth1": `iRWWfNE5NQfUnRrxa0Ei`,
	"depth2": `MX8Px_0xjqhqvIdClZN6`,
	"entry": `RQzdBdO0BUB1LfBXcBa3`,
	"branch": `NVsnwzFr12M19WRAvf9K`,
	"fold": `JpzWoqcAzJYrTM9uAbIL`,
	"detailLine": `lzzE994WS78BwPZhQM5d`,
	"inUse": `cuOlMKe8Jirod7bJH9YY`,
	"restore": `hVS2YPLjzhiOMGWbwvL4`,
	"clear": `I6qTek56fnMs3Md_OBA6`,
	"thumbnail": `wOqAbizyJjJ3XA5s0jC4`,
	"code": `qNkOSWB8ok1aWZsPtf5T ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`
};
export default ___CSS_LOADER_EXPORT___;
